document.addEventListener('DOMContentLoaded', () => {
  const fixedCTA = document.querySelector('[data-fixed-cta]');
  const fixedCTAElement = document.querySelector('[data-fixed-cta-element]');

  if (!fixedCTA) {
    return;
  }

  const handleCTA = (direction) => {
    if (direction === 'down') {
      fixedCTA.classList.add('d-flex');
    } else {
      fixedCTA.classList.remove('d-flex');
    }
  };

  new Waypoint({
    element: fixedCTAElement,
    handler: (direction) => {
      handleCTA(direction);
    },
  });
});
